import { render } from '@testing-library/react';
import React, { Component, useEffect, useState, useLayoutEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { GeoserverGetCapabilities } from '../../services/geoserver/GeoserverCapabilities';
import Meses from '../../services/Meses';

export default function MenuHome() {

  const anos = [2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2111, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023];
  const meses = Meses;

  const [layers, setLayers] = useState([]);
  const [groups, setGroups] = useState([]);
  const [workspaces, setWorkspaces] = useState([]);
  const [menu, setMenu] = useState(new Date().getFullYear());

  useEffect(() => {
    start();
  }, [])

  const start = async () => {

  }

  const handlerMenu = (ano) => {
    if (menu == ano)
      setMenu(null);
    else
      setMenu(ano);
  }

  const CalalogGroup = (props) => {
    return (
      <>
        <li className={menu == props.ano ? 'active open' : ''}><a onClick={() => handlerMenu(props.ano)} href="javascript:void(0);" className="menu-toggle  waves-effect waves-block"><i className="zmdi zmdi-caret-down"></i><span> {props.ano}</span> </a>
          <ul className="ml-menu" style={{ display: menu == props.ano ? 'block' : 'none' }}>
            <CatalogItem workspace={props.ano} layers={props.layers} />
          </ul>
        </li >
      </>
    );
  }

  const CatalogItem = (props) => {
    return (
      <>
        {meses.map(mes => <li key={Math.random()}> <Link to={'/extratos'} key={Math.random()} title={mes.mes} state={{ periodo: { 'mes_id': mes.id, 'mes': mes.mes, 'ano': props.workspace }, 'key': Math.random() }} className="waves-effect waves-classic" > <span> {mes.mes} </span> </Link></li>)}
      </>
    );
  }

  return (
    <>
      <div className="menu">
        <ul className="list">
          {/* <li className="header"><strong> <i className='zmdi zmdi-calendar m-r-5'></i>  &nbsp;MENU HOME </strong></li>
          <li><Link to={'/extratos'} className="waves-effect waves-classic" > <span> EXTRATOS DE REPASSES </span> </Link></li>
          <li><Link to={'/noticias'} className="waves-effect waves-classic" > <span> NOTÍCIAS </span> </Link></li>
          <li><Link to={'/faqs'} className="waves-effect waves-classic" > <span> FAQ's </span> </Link></li>
          <li><Link to={'/historicos'} className="waves-effect waves-classic" > <span> HISTÓRICOS </span> </Link></li>
          <li><Link to={'/legislacoes'} className="waves-effect waves-classic" > <span> LEGISLAÇÕES </span> </Link></li>
          <li><Link to={'/acordos'} className="waves-effect waves-classic" > <span> ACORDOS </span> </Link></li>
          <li><Link to={'http://robin-hood.fjp.mg.gov.br/index.php/parceiros'} className="waves-effect waves-classic" target='_blank' > <span> PARCEIROS </span> </Link></li>
          <li><Link to={'https://fjp.mg.gov.br/fale-conosco/'} className="waves-effect waves-classic" target='_blank' > <span> FALE CONOSCO </span> </Link></li> */}


        </ul>
      </div >
    </>
  );

}
